import React from "react";
import { Modal, Button } from "react-bootstrap";

const PaymentMethodModel = ({
  show,
  handleClose,
  paymentMethod,
  bankAccounts,
  chequeDetails,
  setChequeDetails,
  selectedBankAccount,
  setSelectedBankAccount,
  handleSubmit,
  currencyCode,
  userId,
}) => {
  const handleChequeChange = (e) => {
    const { name, value } = e.target;
    setChequeDetails((prev) => ({
      ...prev,
      [name]: value,
      userId: userId, // Ensure userId is always included
    }));
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {paymentMethod === "BANKACCOUNT"
            ? "Bank Account Details"
            : "Cheque Details"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {paymentMethod === "BANKACCOUNT" && (
          <div className="form-group">
            <label>Select Bank Account</label>
            <select
              className="form-select"
              value={selectedBankAccount}
              onChange={(e) => setSelectedBankAccount(e.target.value)}
              required
            >
              <option value="">Select Bank Account</option>
              {bankAccounts.map((account) => (
                <option
                  key={account.bankAccountId}
                  value={account.bankAccountId}
                >
                  {account.bankName} - {account.accountNumber}
                </option>
              ))}
            </select>
          </div>
        )}

        {paymentMethod === "CHEQUE" && (
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Bank Account</label>
                <select
                  className="form-select"
                  name="bankAccountId"
                  value={chequeDetails.bankAccountId}
                  onChange={handleChequeChange}
                  required
                >
                  <option value="">Select Bank Account</option>
                  {bankAccounts.map((account) => (
                    <option
                      key={account.bankAccountId}
                      value={account.bankAccountId}
                    >
                      {account.bankName} - {account.accountNumber}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Amount ({currencyCode})</label>
                <input
                  type="number"
                  className="form-control"
                  name="amount"
                  value={chequeDetails.amount}
                  onChange={handleChequeChange}
                  placeholder="Enter amount"
                  required
                />
              </div>
              <div className="form-group">
                <label>Cleared Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="clearedDate"
                  value={chequeDetails.clearedDate || ""}
                  onChange={handleChequeChange}
                />
              </div>
              <div className="form-group">
                <label>Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  name="remarks"
                  value={chequeDetails.remarks}
                  onChange={handleChequeChange}
                  placeholder="Enter remarks (optional)"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Cheque Number</label>
                <input
                  type="text"
                  className="form-control"
                  name="chequeNumber"
                  value={chequeDetails.chequeNumber}
                  onChange={handleChequeChange}
                  placeholder="Enter cheque number"
                  required
                />
              </div>
              <div className="form-group">
                <label>Issue Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="issueDate"
                  value={chequeDetails.issueDate}
                  onChange={handleChequeChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Status</label>
                <select
                  className="form-select"
                  name="status"
                  value={chequeDetails.status}
                  onChange={handleChequeChange}
                >
                  <option value="Issued">Issued</option>
                  <option value="Cleared">Cleared</option>
                  <option value="Bounced">Bounced</option>
                  <option value="Pending">Pending</option>
                </select>
              </div>
              <input type="hidden" name="userId" value={userId} />
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentMethodModel;
